import { render } from "./TermInfomation.vue?vue&type=template&id=138c4b23"
import script from "./TermInfomation.vue?vue&type=script&lang=js"
export * from "./TermInfomation.vue?vue&type=script&lang=js"

import exportComponent from "/Users/jeniel/Works/tranggle/old-tranggle-www-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__